import cn from 'clsx';
import { InlineSvg } from 'components/svg';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export interface LookUpButtonProps {
  text?: string;
  onClick?: () => void;
  enabled?: boolean;
  isLoading?: boolean;
  className?: string;
}

export const LookUpButton: FC<LookUpButtonProps> = ({
  text = 'Look up',
  onClick,
  enabled = true,
  isLoading = false,
  className
}) => {
  if (isLoading) {
    return <Skeleton width={70} height={16} borderRadius={4} />;
  }

  return (
    <div
      onClick={enabled ? onClick : undefined}
      className={cn(
        'd-flex gap-1 align-items-center fw-bold',
        {
          'cursor-pointer text-secondary': enabled,
          'opacity-50 text-secondary': !enabled
        },
        className
      )}
    >
      <InlineSvg path="/media/svg/general/arrows-circle.svg" className="text-secondary" />
      {text}
    </div>
  );
};
